import { render, staticRenderFns } from "./right-col.vue?vue&type=template&id=3ee3d5cb&"
import script from "./right-col.vue?vue&type=script&lang=js&"
export * from "./right-col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports